import { memo } from "react";
import { Flex } from "./flex";
import { ProductListItem } from "./product-list-item";
import { ProductListItemQuantity } from "./product-list-item-quantity";
import * as styles from "./product-list-row.module.css";
import { Text } from "./text";

export const ProductListRow = memo(function ProductListRow({
  title,
  imageUrl,
  quantity,
  price,
  variantTitle,
  sku,
  customAttributes,
  bin,
  emphasizeQuantity = true,
  disableTooltip = false,
  imageTooltipPlacement = "left",
}: {
  title: string;
  imageUrl: string | null | undefined;
  quantity: number;
  price: string;
  variantTitle: string | null | undefined;
  sku: string | null | undefined;
  customAttributes?: { key: string; value: string }[];
  bin?: string | null;
  emphasizeQuantity?: boolean;
  disableTooltip?: boolean;
  imageTooltipPlacement?: "left" | "right" | "top" | "bottom";
}) {
  return (
    <Flex flexDirection="column" p="xl" w="full">
      <Flex align="center" gap="lg" justify="space-between" w="full">
        <ProductListItem
          disableTooltip={disableTooltip}
          imageTooltipPlacement={imageTooltipPlacement}
          imageUrl={imageUrl}
          sku={sku}
          title={title}
          variantTitle={variantTitle}
        />
        <Flex align="center" gap="lg">
          {bin && (
            <Text fontSize="xs" textColor="secondary">
              {bin}
            </Text>
          )}
          <ProductListItemQuantity
            emphasizeQuantity={emphasizeQuantity}
            price={price}
            quantity={quantity}
          />
        </Flex>
      </Flex>
      {customAttributes && customAttributes.length > 0 && (
        <ProductListItemAttributes customAttributes={customAttributes} />
      )}
    </Flex>
  );
});

export const ProductListItemAttributes = memo(
  function ProductListItemAttributes({
    customAttributes,
  }: {
    customAttributes: { key: string; value: string }[];
  }) {
    return (
      <Flex flexDirection="column" gap="sm">
        <Text fontSize="xxs">Custom attributes</Text>
        {customAttributes.map((attribute) => (
          <Text fontSize="xxs" key={attribute.key} textColor="tertiary">
            {attribute.key}: {attribute.value}
          </Text>
        ))}
      </Flex>
    );
  },
);

export const ItemTableHeader = memo(function ItemTableHeader({
  flatTopCorners = true,
  showBin = false,
}: {
  flatTopCorners?: boolean;
  showBin?: boolean;
}) {
  return (
    <Flex
      bgColor="secondary"
      borderBottomWidth="1px"
      borderColor="primary"
      borderStyle="solid"
      className={styles.flatBottomCorners}
      justify="space-between"
      px="xl"
      py="lg"
      radius={flatTopCorners ? "none" : "sm"}
      w="full"
    >
      <Text fontSize="xxs" fontWeight="medium">
        Item name
      </Text>

      <Flex gap="lg">
        {showBin && (
          <Text fontSize="xxs" fontWeight="medium">
            Bin
          </Text>
        )}
        <Text
          className={styles.quantityHeader}
          fontSize="xxs"
          fontWeight="medium"
        >
          Quantity
        </Text>
      </Flex>
    </Flex>
  );
});
